<template>
  <div class="full SectionReason">
    <div class="title">
      펀다나우 <b>마이너스 통장</b>을<br/>
      선택하는 이유
    </div>
    <div class="list slow delay-500ms" v-inview:animate="'fadeInUp'" ref="list">
      <carousel
        :autoplay="true"
        :loop="true"
        :mouse-drag="true"
        :per-page="1"
        :perPageCustom="[[600, 2]]"
        :paginationEnabled="false"
        :autoplayTimeout="4000"
        :spacePadding="20">
        <slide>
          <div class="item-container"><One/></div>
        </slide>
        <slide>
          <div class="item-container"><Two/></div>
        </slide>
        <slide>
          <div class="item-container"><Three/></div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import One from './reason/One'
import Two from './reason/Two'
import Three from './reason/Three'
export default {
  name: 'SectionReason',
  components: {
    One,
    Two,
    Three,
  },
  props: {},
  data: function () {
    return {
    }
  },
  computed: {
  },
  async created() {
  },
  destroyed() {},
  methods: {
  },
}
</script>

<style lang="scss" scoped>
  .SectionReason {
    width: 100%;
    background-color: #f2f9ff;
    padding-top: 60px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .title {
      width: 100%;
      font-weight: 800;
      font-size: 25px;
      line-height: 1.36;
      letter-spacing: -0.79px;
      text-align: center;
      color: #333333;

      b {
        color: #1baaf1;
      }
    }

    .list {
      width: 100%;
      margin-top: 30px;
      .item-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 30px;
      }
    }
  }
</style>
